import { ValueType } from '@convergence/types';
import { AnalysisSwitchValue } from './analysis-switch-value';
import { AnalysisValueProps } from './types';

export interface AnalysisRootValueProps {
  value: ValueType;
  analysisSchemaId: number;
  name: string;
}

export function AnalysisRootValue(props: AnalysisRootValueProps) {
  return (
    <AnalysisSwitchValue
      tree={props.value}
      value={props.value}
      propertyPath={[]}
      name={props.name}
    />
  );
}
